import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useDict } from "@/i18n/useDict";

const CtaSection = () => {
  const { dict } = useDict();
  const c = dict.cta;
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    nume: "",
    prenume: "",
    numeClinica: "",
    email: "",
    telefon: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.nume || !form.prenume || !form.email || !form.telefon) {
      toast({ title: c.toastRequired, variant: "destructive" });
      return;
    }
    setLoading(true);
    try {
      await fetch("https://n8n.bogdanpodina.ro/webhook/b453b9b9-7cef-4edd-a75a-d744d9432ac6", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setSubmitted(true);
      toast({ title: c.toastSuccess });
    } catch {
      toast({ title: c.toastError, variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-20 md:py-32 px-6 bg-gradient-cta text-primary-foreground">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold">{c.heading}</h2>
        <p className="mt-4 text-lg opacity-90 leading-relaxed">
          {c.subheading}
        </p>
        <p className="mt-2 text-sm opacity-75">
          {c.note}
        </p>

        {submitted ? (
          <div className="mt-10 rounded-2xl bg-background/10 backdrop-blur p-8">
            <p className="text-xl font-semibold">{c.thanksTitle}</p>
            <p className="mt-2 opacity-90">{c.thanksBody}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 text-left">
            <div>
              <label className="block text-sm font-medium opacity-90 mb-1">{c.labelLastName}</label>
              <input
                type="text"
                name="nume"
                value={form.nume}
                onChange={handleChange}
                required
                className="w-full rounded-xl bg-background/10 backdrop-blur border border-primary-foreground/20 px-4 py-3 text-primary-foreground placeholder:text-primary-foreground/50 focus:outline-none focus:ring-2 focus:ring-background/30"
                placeholder={c.phLastName}
              />
            </div>
            <div>
              <label className="block text-sm font-medium opacity-90 mb-1">{c.labelFirstName}</label>
              <input
                type="text"
                name="prenume"
                value={form.prenume}
                onChange={handleChange}
                required
                className="w-full rounded-xl bg-background/10 backdrop-blur border border-primary-foreground/20 px-4 py-3 text-primary-foreground placeholder:text-primary-foreground/50 focus:outline-none focus:ring-2 focus:ring-background/30"
                placeholder={c.phFirstName}
              />
            </div>
            <div className="sm:col-span-2">
              <label className="block text-sm font-medium opacity-90 mb-1">{c.labelClinic}</label>
              <input
                type="text"
                name="numeClinica"
                value={form.numeClinica}
                onChange={handleChange}
                className="w-full rounded-xl bg-background/10 backdrop-blur border border-primary-foreground/20 px-4 py-3 text-primary-foreground placeholder:text-primary-foreground/50 focus:outline-none focus:ring-2 focus:ring-background/30"
                placeholder={c.phClinic}
              />
            </div>
            <div>
              <label className="block text-sm font-medium opacity-90 mb-1">{c.labelEmail}</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full rounded-xl bg-background/10 backdrop-blur border border-primary-foreground/20 px-4 py-3 text-primary-foreground placeholder:text-primary-foreground/50 focus:outline-none focus:ring-2 focus:ring-background/30"
                placeholder={c.phEmail}
              />
            </div>
            <div>
              <label className="block text-sm font-medium opacity-90 mb-1">{c.labelPhone}</label>
              <input
                type="tel"
                name="telefon"
                value={form.telefon}
                onChange={handleChange}
                required
                className="w-full rounded-xl bg-background/10 backdrop-blur border border-primary-foreground/20 px-4 py-3 text-primary-foreground placeholder:text-primary-foreground/50 focus:outline-none focus:ring-2 focus:ring-background/30"
                placeholder={c.phPhone}
              />
            </div>
            <div className="sm:col-span-2 mt-2">
              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-xl bg-background text-primary px-8 py-3.5 text-base font-semibold hover:opacity-90 transition-opacity disabled:opacity-60"
              >
                {loading ? c.submitting : c.submit}
              </button>
            </div>
          </form>
        )}

        <p className="mt-6 text-sm opacity-75">
          {c.emailLabel}{" "}
          <a href="mailto:contact@optify.ro" className="underline">contact@optify.ro</a>
        </p>
      </div>
    </section>
  );
};

export default CtaSection;
